import {
    type DeleteCompanyRequestResponseType,
    type DeleteCompanyRequestRequestType
} from "./types";
import axios from "axios";
import {
    SERVER_ADDRESS
} from "../../constants";
import {
    getHeaders
} from "../../utils";

const DeleteCompanyRequest = async (params: DeleteCompanyRequestRequestType): Promise<DeleteCompanyRequestResponseType> => {
    return await axios(`${SERVER_ADDRESS}/profile/deleteCompanyRequest`, {
        method: "DELETE",
        headers: getHeaders(true),
        data: params
    })
        .then((res) => {
            if (
                res.status === 200 ||
                res.status === 201 ||
                res.status === 202
            ) {
                return res.data;
            }

            throw res;
        })
        .catch((err) => {
            if (err && err.response && err.response.data) {
                throw err.response.data;
            }

            throw err;
        });
};
export default DeleteCompanyRequest;
